import ErrorReportPopOver from "#/components/exam-results/descriptivePage/ErrorReportPopOver";
import { useBreakLG } from "@monta/design-system";
import { DescriptiveQuestionSidebar as Sidebar } from "../Sidebar";
import type { DqGlobalProps } from "../types";
import styles from "./dqHeader.module.scss";
import { QuestionStatus as Status } from "./QuestionStatus";
import { QuestionTopic as Topic } from "./QuestionTopic";

export const DescriptiveQuestionHeader = (props: DqGlobalProps) => {
  const { id } = props;

  const isLG = useBreakLG();

  return (
    <header className={styles["dq-header"]}>
      <div className={styles["dq-header__status-and-report-container"]}>
        {isLG ? (
          <>
            <Status id={id} />
            <ErrorReportPopOver id={id} />
          </>
        ) : (
          <div
            className={
              styles["dq-header__status-and-report-container--mobile-view"]
            }
          >
            <div>
              <Sidebar id={id} />
              <ErrorReportPopOver id={id} />
            </div>
            <Status id={id} />
          </div>
        )}
      </div>
      <Topic id={id} />
    </header>
  );
};
